<template>
  <PageShell class="page-shell-wrapper--download" locale="id" :page-title="pageTitle" hide-title>
    <article class="wagb-download">
      <section class="wagb-download__hero">
        <div class="wagb-download__hero-bg" aria-hidden="true">
          <span class="wagb-download__blob wagb-download__blob--tr" />
          <span class="wagb-download__blob wagb-download__blob--bl" />
        </div>

        <div class="wagb-download__hero-inner">
          <!-- 左侧：转化区（下载） -->
          <div class="wagb-download__hero-copy">
            <h1>{{ pageTitle }}</h1>
            <p class="wagb-download__lead">
              GB WhatsApp versi terbaru dengan fitur tambahan, privasi lebih fleksibel, dan tampilan yang bisa
              dikustomisasi.
            </p>

            <div class="wagb-download__actions">
              <button type="button" class="wagb-download__button" @click="downloadApk">
                <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
                  <path
                    fill="currentColor"
                    d="M12 3a1 1 0 0 1 1 1v9.586l2.293-2.293a1 1 0 1 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 1 1 1.414-1.414L11 13.586V4a1 1 0 0 1 1-1z"
                  />
                  <path fill="currentColor" d="M4 18a1 1 0 0 1 1-1h14a1 1 0 0 1 0 2H5a1 1 0 0 1-1-1z" />
                </svg>
                Unduh APK Sekarang
              </button>
              <a class="wagb-download__link" href="#panduan-install">
                <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
                  <path
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    d="M12 5v10M8 11l4 4 4-4"
                  />
                  <path fill="none" stroke="currentColor" stroke-width="2" d="M5 19h14" />
                </svg>
                Lihat panduan install
              </a>
            </div>

            <p class="wagb-download__note">
              <span class="wagb-download__note-icon" aria-hidden="true">!</span>
              Pastikan backup data sebelum instalasi untuk menghindari kehilangan chat.
            </p>
          </div>

          <!-- 右侧：信任区（Logo + 版本标签） -->
          <aside class="wagb-download__hero-trust" aria-label="Informasi APK">
            <div class="wagb-download__trust-panel">
              <img
                class="wagb-download__trust-logo"
                :src="heroMockup"
                alt="GB WhatsApp APK"
                width="80"
                height="80"
                loading="eager"
              />
              <div class="wagb-download__pills">
                <span v-for="item in heroPills" :key="item">{{ item }}</span>
              </div>
            </div>
          </aside>
        </div>
      </section>

      <section class="wagb-download__section">
        <div class="wagb-download__content">
          <h2>Kenapa Memilih WA GB APK {{ apk.version }}?</h2>
          <p>
            <a href="/">WA GB</a> {{ apk.version }} memberikan pengalaman penggunaan yang lebih fleksibel dibandingkan
            WhatsApp resmi. Dengan pembaruan terbaru ini, pengguna bisa menikmati performa yang lebih stabil, fitur
            privasi yang lebih lengkap, serta tampilan yang bisa disesuaikan sesuai kebutuhan.
          </p>
          <p>
            Aplikasi ini juga dirancang agar tetap ringan digunakan di berbagai perangkat Android, sehingga cocok untuk
            penggunaan harian tanpa mengganggu performa ponsel.
          </p>
        </div>
      </section>

      <section class="wagb-download__section wagb-download__section--muted">
        <div class="wagb-download__content">
          <h2>Keamanan &amp; Catatan</h2>
          <p>
            Sebelum menginstal, pastikan kamu sudah melakukan backup data agar chat tidak hilang. WA GB APK adalah
            aplikasi modifikasi, sehingga tidak tersedia di Google Play Store dan perlu diinstal secara manual melalui
            file APK.
          </p>
        </div>
      </section>

      <section id="panduan-install" class="wagb-download__section wagb-download__guide">
        <div class="wagb-download__content">
          <header class="wagb-download__section-head">
            <h2>Cara Unduh &amp; Install WA GB APK di Android</h2>
            <p>
              WhatsApp GB WhatsApp adalah aplikasi modifikasi, jadi <strong>tidak tersedia di Google Play Store</strong>,
              dan harus diunduh melalui file APK dari sumber pihak ketiga.
            </p>
            <p>Berikut langkah-langkah install di Android:</p>
          </header>

          <div class="wagb-download__steps">
            <template v-for="(step, index) in installSteps">
              <article :key="step.title" class="wagb-download__step">
                <span class="wagb-download__step-num">{{ formatStep(index + 1) }}</span>
                <h3>{{ step.title }}</h3>

                <div class="wagb-download__shot">
                  <img
                    :src="step.image"
                    :alt="`Screenshot ${formatStep(index + 1)} - ${step.title}`"
                    width="220"
                    height="380"
                    loading="lazy"
                  />
                </div>

                <div class="wagb-download__step-copy">
                  <p v-if="stepIntro(step)" class="wagb-download__step-intro">{{ stepIntro(step) }}</p>
                  <ul>
                    <li v-for="item in step.items" :key="item">{{ item }}</li>
                  </ul>
                </div>
              </article>
            </template>
          </div>
        </div>
      </section>

      <section class="wagb-download__section wagb-download__section--muted">
        <div class="wagb-download__content">
          <h2>Catatan penting</h2>
          <p>GB WhatsApp bukan aplikasi resmi dari WhatsApp, sehingga:</p>
          <ul class="wagb-download__warning-list">
            <li>Tidak ada di Play Store</li>
            <li>Risiko keamanan &amp; privasi lebih tinggi</li>
            <li>Bisa berpotensi diblokir</li>
          </ul>
        </div>
      </section>

      <section class="wagb-download__section">
        <div class="wagb-download__cta">
          <h2>Siap Download?</h2>
          <p>
            Nikmati fitur lengkap WA GB APK {{ apk.version }} sekarang di perangkat Android kamu dan rasakan pengalaman
            chatting yang lebih bebas dan fleksibel.
          </p>
          <button type="button" class="wagb-download__button wagb-download__button--lg" @click="downloadApk">
            Unduh APK Sekarang
          </button>
        </div>
      </section>
    </article>
  </PageShell>
</template>

<script>
import '@/css/wagbappro-download.scss';
import PageShell from '@/components/layout/PageShell.vue';
import siteConfig from '@/config/site';
import { installSteps } from '@/data/wagbappro/home-id';

export default {
  name: 'DownloadPage',
  components: {
    PageShell,
  },
  data() {
    return {
      apk: siteConfig.apk,
      heroMockup: require('@/assets/wagbappro/ui-mockups/13-ui-download-page-mockup.webp'),
      installSteps,
      apkUrl: process.env.VUE_APP_GBLINK || process.env.VUE_APP_DEFAULT_APK,
    };
  },
  computed: {
    pageTitle() {
      return this.$route.meta.pageTitle || `Download WA GB APK ${this.apk.version} untuk Android`;
    },
    heroPills() {
      return [this.apk.version, `Android ${this.apk.android}`, this.apk.size, 'Anti Ban'];
    },
  },
  methods: {
    downloadApk() {
      if (this.apkUrl && this.$global && this.$global.download) {
        this.$global.download(this.apkUrl);
      }
    },
    formatStep(num) {
      return String(num).padStart(2, '0');
    },
    stepIntro(step) {
      const intros = {
        'Aktifkan "Sumber Tidak Dikenal"': 'Sebelum install, Android harus diizinkan:',
        'Pengaturan tambahan (opsional)': 'Beberapa pengguna biasanya juga melakukan:',
      };

      return intros[step.title] || '';
    },
  },
};
</script>
